import {
  ScriveWorkflowJobState,
  ScriveWorkflowJobMutationTypes,
  ScriveSignersTabModel,
  FieldUpdateModel
} from '@/types';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<ScriveWorkflowJobState> = {
  [ScriveWorkflowJobMutationTypes.SetIsSignersTabLoading](state, isLoading: boolean) {
    state.isScriveSignersTabLoading = isLoading;
  },
  [ScriveWorkflowJobMutationTypes.SignersTabLoaded](state, payload: ScriveSignersTabModel) {
    state.errorMessage = '';
    state.error = false;
    state.scriveSignersTab = payload;
    state.isScriveSignersTabLoading = false;
  },
  [ScriveWorkflowJobMutationTypes.SignersTabError](state, payload: any) {
    state.errorMessage = JSON.stringify(payload);
    state.error = true;
    state.scriveSignersTab = {} as ScriveSignersTabModel;
    state.isScriveSignersTabLoading = false;
  },
  [ScriveWorkflowJobMutationTypes.UpdateSignersDataSourceFieldValue](state, payload: FieldUpdateModel) {
    if (state.scriveSignersTab && state.scriveSignersTab.scriveSignersDataSource) {
      (state.scriveSignersTab.scriveSignersDataSource.fields as any)[payload.fieldName] = payload.value;
    }
  },
  [ScriveWorkflowJobMutationTypes.UnloadSignersWorkflowJob](state, payload) {
    const initState = {
      scriveSignersTab: {} as ScriveSignersTabModel,
      isScriveSignersTabLoading: true,
      isLoading: false,
      error: false,
      errorMessage: ''
    } as ScriveWorkflowJobState;
    Object.assign(state, initState);
  }
};
